import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
// import PersonIcon from '@mui/icons-material/Person'
import { getSuscriberRefId } from '../../../app/services/Suscriber/getSuscriberFromRefId'
import { useParams } from 'react-router-dom'
import useStyles from './useStyle'
import UsersTable from './TableNavigable/TableNavigable'
import OrganizationBreadcrumbs from '../Organizations/Breadcrumbs/Breadcrumbs'
import {
  SnackBarError,
  SnackBarSuccess
} from '../../../components/SnackBars/SnackBars'
import InfoIcon from '@mui/icons-material/Info'

export default function UsersForSuscriber () {
  const { id } = useParams()
  const classes = useStyles()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [suscriber, setsuscriber] = useState(null)

  // const [isOrgTesting, setisOrgTesting] = useState(false)

  // get organization request
  const getOrganizationwithSuscriberID = async () => {
    try {
      const params = {
        clicod: id
      }
      const response = await getSuscriberRefId(params)
      setsuscriber(response.data)
      // const orgIstesting = await isOrganizationTesting(
      //   response.data?.organization_id
      // )
      // setisOrgTesting(orgIstesting)
    } catch (error) {}
  }
  // get Organization
  useEffect(async () => {
    setLoading(true)
    await getOrganizationwithSuscriberID()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <OrganizationBreadcrumbs />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Usuarios asociados a un suscriptor
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los usuarios del suscriptor{' '}
          {suscriber ? suscriber.subscriber_name : ''}.
        </Typography>
      </div>

      <SnackBarSuccess />
      <SnackBarError />
      <div className={classes.boxTable}>
        <UsersTable
          id={id}
          // isOrgTesting={isOrgTesting}
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
